import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function PrivateRoute({ Layout }) {
  const { user } = useAuth();
  const location = useLocation();
  console.log("PrivateRoute user:", user);
  console.log("PrivateRoute location:", location);

  if (!user) {
    // This log will help you confirm why it's redirecting
    console.warn("Redirecting to login because user is not authenticated");
    return <Navigate to="/login" replace />;
  }

  return Layout ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Outlet />
  );
}
